// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"10fa5356","101":"10fa5356","132":"10fa5356","195":"674e62c8","464":"1a5cf9f3","594":"10fa5356","982":"10fa5356"}[chunkId] + ".chunk.css";
};